import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Contacts from './pages/Contact';
import Complains from './pages/Complains'
import Electricity from './pages/Electricity';
import Gas from './pages/Gas';
import Merchant from './pages/Merchant';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Contacts" element={<Contacts />} />
        <Route path="/Complains" element={<Complains />} />
        <Route path="/services/electricity" element={<Electricity />} />
        <Route path="/services/gas" element={<Gas />} />
        <Route path="/services/merchant" element={<Merchant />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;